import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { loadVoLteResourceList, transformStr3, getformDetailitemsdata, handleHttp } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'scenicspotdetail',
  meta: {
    title: '景点'
  },
  data() {
    return {
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      // this.$route.query.cfId
      formconfig: {
        formId: '264843_1',
        page: 1,
        limit: 10
      },
      detail: {},
      total: 0,
      gpimg: require('@/assets/images/gp.jpg'),
      swiperEl: '' // 弹窗轮播图ref
    };
  },
  created() {},
  mounted() {
    this.getDetail();
    // loadVoLteResourceList(['https://portal.chaoxing.com/outer/187596/header'])
  },
  methods: {
    getDetail() {
      let _this = this;
      this.$api.singleformUserId(this.fid, this.formconfig.formId, this.formUserId).then(res => {
        let formData = res.formUserList[0].formData;
        formData.forEach(item => {
          _this.detail[transformStr3(item.alias)] = getformDetailitemsdata(item);
        });
        _this.detail[38] === '' ? _this.detail.bannerList = _this.detail[3] : _this.detail.bannerList = _this.detail[38];
        if (_this.detail[25].length > 0) {
          _this.gpimg = _this.setHttp(_this.detail[25][0].fileUrl);
        }
        // console.log(JSON.parse(JSON.stringify(_this.detail)))
        this.swiperEl = new Swiper(this.$refs.swipercontainer, {
          initialSlide: 0,
          pagination: {
            el: this.$refs.swiperpage
          },
          autoplay: true,
          observeSlideChildren: true,
          observeParents: true,
          observer: true
        });
      });
    },
    setHttp(val) {
      return handleHttp(val);
    }
  }
};